<template>
  <div class="containerRepresentante">
    <DeclaracoesDocumentosList
      tipoClienteKey="Investidor"
      :showStatusButton="true"
      :showRefresh="true"
      :useImpressaoFlag="false"
      :enablePolling="true"
    >
      <template #header-extra>
        <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações'" :TipoCliente="'Fundos'" :Sessao="'Declarações'" :SubSessao="'Declarações'"/>
      </template>
    </DeclaracoesDocumentosList>
  </div>
</template>


<script>
import DeclaracoesDocumentosList from '@/components/Declaracoes/DeclaracoesDocumentosList.vue';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue';

export default {
  name: 'CadastroPF_Representantes',
  props: ['Edicao'],
  components: { DeclaracoesDocumentosList, LabelDisclaimer },
};

</script>


<style lang="scss" scoped>
</style>